import ManagedTable, { ManagedColumn, ManagedColumnExtra, ManagedTableProps } from 'app/common/table/ManagedTable';
import { OpsInstruction } from 'app/model/SOL49';
import TimeUtils from 'app/common/util/TimeUtils';
import { CheckCircleFilled } from '@ant-design/icons';
import useWindowDimensions from 'app/common/hooks/useWindowDimensions';
import React from 'react';
import './OpsInstructionsTable.less';

class OpsInstructionsColumn extends ManagedColumn<OpsInstruction> {
    constructor(
        header: string,
        width: string,
        getCellValue: (object: OpsInstruction) => any,
        extra?: ManagedColumnExtra<OpsInstruction>,
    ) {
        super(header, width, getCellValue, extra);
    }
}

export class StandardOpsInstructionsColumn {
    public static readonly TITLE = new OpsInstructionsColumn('TITLE', '30em', event => event.title, {
        wordWrapEnabled: true,
    });
    public static readonly LAST_UPDATE = new OpsInstructionsColumn('Last update', '10em', event =>
        TimeUtils.getDayMonthTime(event.lastUpdate),
    );
}

export const OPS_INSTRUCTIONS_SELECTED_COLUMN = new OpsInstructionsColumn(
    '',
    '2em',
    () => (
        <div className={'check-circle'} style={{ textAlign: 'center' }}>
            <CheckCircleFilled />
        </div>
    ),
    { name: 'selected' },
);

export const OpsInstructionsColumns = [
    OPS_INSTRUCTIONS_SELECTED_COLUMN,
    StandardOpsInstructionsColumn.LAST_UPDATE,
    StandardOpsInstructionsColumn.TITLE,
];

class OpsInstructionsTableBase extends ManagedTable<OpsInstruction> {}

const OpsInstructionsTable = (props: ManagedTableProps<OpsInstruction>) => {
    const { width } = useWindowDimensions();
    const fontSize = (0.42 * width) / 100;

    return <OpsInstructionsTableBase fontSize={fontSize} {...props} />;
};

export default OpsInstructionsTable;
